import React from 'react';
import { Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import SubmitAssessment from 'components/JobAssessment/SubmitAssessment';
import './styles.scss';
import useTranslate from 'hooks/useTranslate';

const ApplyJobAssessment: React.FC = () => {
	const navigate = useNavigate();
	const { translate } = useTranslate();

	return (
		<section className="apply-job-questionnaire py-50 position-relative">
			<Container fluid>
				<Link to="" onClick={() => navigate(-1)} className="back-link">
					<i className="ri-arrow-left-line"></i> {translate('Common.backToList')}
				</Link>
				<SubmitAssessment />
			</Container>
		</section>
	);
};

export default ApplyJobAssessment;
